<template>
    <div>
        <div class="top_container" v-show="this.scroll100==true">
            <div class="nav_container" >
              <div @click="goToHome">
                <img src="../../static/img/logos.png" style="width: 100%;margin-top: 25px;margin-left: 5px;" alt />
              </div>
              <div class="nav">
                <ul>
                  <li class="navhover">
                    <a @click="goToHome">首页</a>
                  </li>
                  <li class="navhover">
                      <a @click="goToBrand">品牌案例</a>
                  </li>
                  <li class="navhover">
                    <a @click="goToDw">产品中心</a>
                    <div class="navchild">
                      <div class="navchild1 navchild2">
                        <a @click="goToDw" class="div_size_font">店务系统介绍</a>
                      </div>
                      <div class="navchild1 navchild2">
                        <a @click="goToSupply" class="div_size_font">供应链介绍</a>
                      </div>
                      <div class="navchild1">
                        <a @click="goToMark" class="div_size_font">营销工具介绍</a>
                      </div>
                    </div>
                  </li>
                  <li class="navhover">
                    <a @click="goToContact">最新动态</a>
                  </li>
                  <li class="navhover">
                    <a @click="goToCulture">企业文化</a>
                  </li>
                  <li class="navhover">
                    <a @click="goToChannel">合作渠道</a>
                  </li>
                  <li class="navhover">
                    <a @click="goToUS">公司简介</a>
                  </li>
                  <!-- <li class="navhover">
                    <a @click="goToCollege">找美商学院</a>
                    <div class="navchildbus">
                      <div class="navchild1 navchild2">
                        <a @click="goToCollege" class="div_size_font">学院文化</a>
                      </div>
                      <div class="navchild1 navchild2">
                        <a @click="goToAli" class="div_size_font">走进阿里</a>
                      </div>
                      <div class="navchild1 ">
                        <a @click="gotoTravell" class="div_size_font">行程安排</a>
                      </div>
                    </div>
                  </li> -->
                </ul>
              </div>
              <div class="logu">
                <img src="../../static/img/chinese.png" alt class="log_img" />
                <div class="log_text">简体中文</div>
              </div>
            </div>
          </div>
         
        <div class="nav_container2" v-show="this.scroll700==true">
            <div class="nav_box">
                <div style="height: 50px;" @click="goToHome">
                    <img src="../../static/img/logos.png" alt="" style="height: 50px">
                </div>
                <div class="nav2" style="margin-left: 0px;">
                    <ul>
                        <li class="navhover2">
                            <a @click="goToHome">首页</a>
                        </li>
                        <li class="navhover">
                            <a @click="goToBrand">品牌案例</a>
                        </li>
                        <li class="navhover2">
                            <a @click="goToDw">产品中心</a>
                            <div class="navchildpro">
                            <div class="navchild3 navchild4">
                                <a @click="goToDw" class="div_size_font">店务系统介绍</a>
                            </div>
                            <div class="navchild3 navchild4">
                                <a @click="goToSupply" class="div_size_font">供应链介绍</a>
                            </div>
                            <div class="navchild3">
                                <a @click="goToMark" class="div_size_font">营销工具介绍</a>
                            </div>
                            </div>
                        </li>
                        <li class="navhover2">
                            <a @click="goToContact">最新动态</a>
                        </li>
                    
                        <li class="navhover2">
                            <a @click="goToCulture">企业文化</a>
                        </li>
                        <li class="navhover2">
                            <a @click="goToChannel">合作渠道</a>
                        </li>
                        <li class="navhover2">
                            <a @click="goToUS">公司简介</a>
                        </li>
                        <!-- <li class="navhover2">
                            <a @click="goToCollege">找美商学院</a>
                            <div class="navchildbus2">
                            <div class="navchild3 navchild4">
                                <a @click="goToCollege" class="div_size_font">学院文化</a>
                            </div>
                            <div class="navchild3 navchild4">
                                <a @click="goToAli" class="div_size_font">走进阿里</a>
                            </div>
                            <div class="navchild3 ">
                                <a @click="gotoTravell" class="div_size_font">行程安排</a>
                            </div>
                            </div>
                        </li> -->
                    </ul>
                </div>
                <div class="language">
                    <img src="../../static/img/chinese.png" alt class="language_img" />
                    <div class="log_text">简体中文</div>
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
    export default {
        props:['scroll100','scroll700'],
        data() {
            return {
                // scroll100: true,
                // scroll700: false
            }
        },
        mounted() {
        },
        watch: {
            scroll: function () {
                this.loadSroll();
            }
        },
        methods: {
            //首页
            goToHome() {
                this.$router.push("/");
            },
            goToBrand(){//品牌案例
                this.$router.push("./RMBrand");
            },
            //产品中心-店务系统介绍
            goToDw() {
                this.$router.push("./home");
            },
            //产品中心-供应链
            goToSupply() {
                this.$router.push("./supplyChain");
            },
            //产品中心-营销工具
            goToMark() {
                this.$router.push("./marketingTools");
            },
            //关于我们-公司简介
            goToUS() {
                this.$router.push("./company");
            },
            //关于我们-合作渠道
            goToChannel() {
                this.$router.push("./channels");
            },
            //关于我们-招聘
            goToContact() {
                this.$router.push("./contact");
            },
            //关于我们-企业文化
            goToCulture() {
                this.$router.push("./culture");
            },
            //更多商家
            goToMore() {
                // this.$router.push("./moreShop");
            },
            //找美商学院-商学院文化
            goToCollege(){
                this.$router.push("./school");
            },
            //找美商学院-走进阿里
            goToAli(){
                this.$router.push("./Ali");
            },
            //找美商学院-行程安排
            gotoTravell(){
                this.$router.push('./Travell')
            },
        }
    }
</script>
<style scoped>
    .div_size_font{
        font-size: 14px;
    }

</style>


// WEBPACK FOOTER //
// src/page/RMTopDiv.vue